declare namespace $ {

	type $mol_button_minor__attr_shm_hitalama_map_catalog_1 = $mol_type_enforce<
		({ 
			'favorite': ReturnType< $shm_hitalama_map_catalog['map_favorite'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_catalog_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['favorite_hint'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__event_click_shm_hitalama_map_catalog_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['favorite_toggle'] >
		,
		ReturnType< $mol_button_minor['event_click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_catalog_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__attr_shm_hitalama_map_catalog_5 = $mol_type_enforce<
		({ 
			'favorite': ReturnType< $shm_hitalama_map_catalog['map_favorite'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_hitalama_map_catalog_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__attr_shm_hitalama_map_catalog_7 = $mol_type_enforce<
		({ 
			'editor': ReturnType< $shm_hitalama_map_catalog['editor_mode_current'] >,
		})  & ReturnType< $mol_link['attr'] >
		,
		ReturnType< $mol_link['attr'] >
	>
	type $mol_link__hint_shm_hitalama_map_catalog_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['hint'] >
	>
	type $mol_link__sub_shm_hitalama_map_catalog_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__arg_shm_hitalama_map_catalog_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['editor_mode_link'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_view__attr_shm_hitalama_map_catalog_11 = $mol_type_enforce<
		({ 
			'editor': ReturnType< $shm_hitalama_map_catalog['editor_mode_current'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_hitalama_map_catalog_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_svg_title__title_shm_hitalama_map_catalog_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['public_hint'] >
		,
		ReturnType< $mol_svg_title['title'] >
	>
	type $mol_icon_earth__sub_shm_hitalama_map_catalog_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_icon_earth['sub'] >
	>
	type $mol_dimmer__needle_shm_hitalama_map_catalog_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['menu_filter'] >
		,
		ReturnType< $mol_dimmer['needle'] >
	>
	type $mol_dimmer__haystack_shm_hitalama_map_catalog_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['spread_title'] >
		,
		ReturnType< $mol_dimmer['haystack'] >
	>
	type $mol_view__sub_shm_hitalama_map_catalog_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check__aria_role_shm_hitalama_map_catalog_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check['aria_role'] >
	>
	type $mol_check__checked_shm_hitalama_map_catalog_19 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_check__clicks_shm_hitalama_map_catalog_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['project_rename_start'] >
		,
		ReturnType< $mol_check['clicks'] >
	>
	type $mol_check__sub_shm_hitalama_map_catalog_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_check['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_catalog_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['project_menu_rename'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_catalog_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_catalog_24 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_catalog_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['project_delete'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_catalog_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_list__sub_shm_hitalama_map_catalog_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['project_menu_items'] >
		,
		ReturnType< $mol_list['sub'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_catalog_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_catalog_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['add_map'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_catalog_30 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_catalog_31 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['add_map'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_catalog_32 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_catalog_33 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['add_map'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_catalog_34 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_catalog_35 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['add_project'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_catalog_36 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $shm_hitalama_attach__attach_title_shm_hitalama_map_catalog_37 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_attach['attach_title'] >
	>
	type $shm_hitalama_attach__attach_new_shm_hitalama_map_catalog_38 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['import'] >
		,
		ReturnType< $shm_hitalama_attach['attach_new'] >
	>
	type $mol_list__sub_shm_hitalama_map_catalog_39 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['sub'] >
	>
	type $mol_pop_over__align_shm_hitalama_map_catalog_40 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pop_over['align'] >
	>
	type $mol_pop_over__Anchor_shm_hitalama_map_catalog_41 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['Add_map_anchor'] >
		,
		ReturnType< $mol_pop_over['Anchor'] >
	>
	type $mol_pop_over__bubble_content_shm_hitalama_map_catalog_42 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pop_over['bubble_content'] >
	>
	type __shm_hitalama_map_catalog_43 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_catalog['sort_order'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_catalog['List_head'] >['sort_order'] >[0]
	>
	type $shm_list_head__title_shm_hitalama_map_catalog_44 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['menu_title'] >
		,
		ReturnType< $shm_list_head['title'] >
	>
	type $shm_list_head__add_content_shm_hitalama_map_catalog_45 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_list_head['add_content'] >
	>
	type $shm_list_head__close_shm_hitalama_map_catalog_46 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['close_maps_list'] >
		,
		ReturnType< $shm_list_head['close'] >
	>
	type $shm_list_head__filter_shm_hitalama_map_catalog_47 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['menu_filter'] >
		,
		ReturnType< $shm_list_head['filter'] >
	>
	type $shm_list_head__sort_by_shm_hitalama_map_catalog_48 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['sort_by'] >
		,
		ReturnType< $shm_list_head['sort_by'] >
	>
	type $shm_hitalama_guide_toggle__section_shm_hitalama_map_catalog_49 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_guide_toggle['section'] >
	>
	type $shm_hitalama_map_page__entity_shm_hitalama_map_catalog_50 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['entity'] >
		,
		ReturnType< $shm_hitalama_map_page['entity'] >
	>
	type $shm_hitalama_map_book__entity_shm_hitalama_map_catalog_51 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['entity'] >
		,
		ReturnType< $shm_hitalama_map_book['entity'] >
	>
	type $shm_hitalama_map_catalog_menu_link_content__52 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['map_title_content'] >[number]
		,
		$mol_view_content
	>
	type $mol_link__arg_shm_hitalama_map_catalog_53 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['menu_link_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_shm_hitalama_map_catalog_54 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['menu_link_content'] >
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__event_shm_hitalama_map_catalog_55 = $mol_type_enforce<
		({ 
			dblclick( next?: ReturnType< $shm_hitalama_map_catalog['map_rename_start'] > ): ReturnType< $shm_hitalama_map_catalog['map_rename_start'] >,
		})  & ReturnType< $mol_link['event'] >
		,
		ReturnType< $mol_link['event'] >
	>
	type $mol_string__value_shm_hitalama_map_catalog_56 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['map_title_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_hitalama_map_catalog_57 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['map_rename_submit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_shm_hitalama_map_catalog_58 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $shm_hitalama_map_catalog['map_rename_pointerdown'] > ): ReturnType< $shm_hitalama_map_catalog['map_rename_pointerdown'] >,
			click( next?: ReturnType< $shm_hitalama_map_catalog['map_rename_click'] > ): ReturnType< $shm_hitalama_map_catalog['map_rename_click'] >,
			blur( next?: ReturnType< $shm_hitalama_map_catalog['map_rename_submit'] > ): ReturnType< $shm_hitalama_map_catalog['map_rename_submit'] >,
			keydown( next?: ReturnType< $shm_hitalama_map_catalog['map_rename_keydown'] > ): ReturnType< $shm_hitalama_map_catalog['map_rename_keydown'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $mol_view__sub_shm_hitalama_map_catalog_59 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_catalog_60 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['map_menu_links'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_dragtree__drag_hold_delay_shm_hitalama_map_catalog_61 = $mol_type_enforce<
		number
		,
		ReturnType< $shm_hitalama_dragtree['drag_hold_delay'] >
	>
	type $shm_hitalama_dragtree__drag_hold_move_threshold_shm_hitalama_map_catalog_62 = $mol_type_enforce<
		number
		,
		ReturnType< $shm_hitalama_dragtree['drag_hold_move_threshold'] >
	>
	type $shm_hitalama_dragtree__drag_touch_action_shm_hitalama_map_catalog_63 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_dragtree['drag_touch_action'] >
	>
	type $shm_hitalama_dragtree__roots_shm_hitalama_map_catalog_64 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['owned_tree_roots'] >
		,
		ReturnType< $shm_hitalama_dragtree['roots'] >
	>
	type $shm_hitalama_dragtree__children_shm_hitalama_map_catalog_65 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['owned_tree_children'] >
		,
		ReturnType< $shm_hitalama_dragtree['children'] >
	>
	type $shm_hitalama_dragtree__expanded_shm_hitalama_map_catalog_66 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['project_expanded'] >
		,
		ReturnType< $shm_hitalama_dragtree['expanded'] >
	>
	type $shm_hitalama_dragtree__can_have_children_shm_hitalama_map_catalog_67 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['owned_tree_can_have_children'] >
		,
		ReturnType< $shm_hitalama_dragtree['can_have_children'] >
	>
	type $shm_hitalama_dragtree__can_be_child_shm_hitalama_map_catalog_68 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['owned_tree_can_be_child'] >
		,
		ReturnType< $shm_hitalama_dragtree['can_be_child'] >
	>
	type $shm_hitalama_dragtree__item_height_shm_hitalama_map_catalog_69 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['owned_tree_item_height'] >
		,
		ReturnType< $shm_hitalama_dragtree['item_height'] >
	>
	type $shm_hitalama_dragtree__Item_shm_hitalama_map_catalog_70 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['Owned_tree_item'] >
		,
		ReturnType< $shm_hitalama_dragtree['Item'] >
	>
	type $mol_view__sub_shm_hitalama_map_catalog_71 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['project_item_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pick__align_shm_hitalama_map_catalog_72 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align'] >
	>
	type $mol_pick__bubble_offset_shm_hitalama_map_catalog_73 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['project_menu_offset'] >
		,
		ReturnType< $mol_pick['bubble_offset'] >
	>
	type $mol_pick__bubble_align_shm_hitalama_map_catalog_74 = $mol_type_enforce<
		readonly(number)[]
		,
		ReturnType< $mol_pick['bubble_align'] >
	>
	type $mol_pick__Anchor_shm_hitalama_map_catalog_75 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['Project_title'] >
		,
		ReturnType< $mol_pick['Anchor'] >
	>
	type $mol_pick__event_shm_hitalama_map_catalog_76 = $mol_type_enforce<
		({ 
			contextmenu( next?: ReturnType< $shm_hitalama_map_catalog['project_contextmenu'] > ): ReturnType< $shm_hitalama_map_catalog['project_contextmenu'] >,
		})  & ReturnType< $mol_pick['event'] >
		,
		ReturnType< $mol_pick['event'] >
	>
	type $mol_pick__bubble_content_shm_hitalama_map_catalog_77 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_button_major__title_shm_hitalama_map_catalog_78 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_hitalama_map_catalog_79 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['project_delete_confirm'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__sub_shm_hitalama_map_catalog_80 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_catalog_81 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_catalog_82 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['project_delete_cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_catalog_83 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_catalog_84 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_catalog_85 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['project_delete_undo'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_catalog_86 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_string__value_shm_hitalama_map_catalog_87 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['project_title_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_hitalama_map_catalog_88 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['project_rename_submit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_shm_hitalama_map_catalog_89 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $shm_hitalama_map_catalog['project_rename_pointerdown'] > ): ReturnType< $shm_hitalama_map_catalog['project_rename_pointerdown'] >,
			blur( next?: ReturnType< $shm_hitalama_map_catalog['project_rename_submit'] > ): ReturnType< $shm_hitalama_map_catalog['project_rename_submit'] >,
			keydown( next?: ReturnType< $shm_hitalama_map_catalog['project_rename_keydown'] > ): ReturnType< $shm_hitalama_map_catalog['project_rename_keydown'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $mol_text__text_shm_hitalama_map_catalog_90 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_shm_hitalama_map_catalog_91 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	export class $shm_hitalama_map_catalog extends $shm_hitalama_entity_catalog {
		favorites_migration_auto( ): any
		map_summaries_migration_auto( ): any
		map_favorite( id: any): boolean
		favorite_hint( id: any): string
		favorite_toggle( id: any, next?: any ): any
		Favorite_icon( id: any): $mol_icon_star
		Favorite( id: any): $mol_button_minor
		Favorite_action( id: any): $mol_view
		editor_mode_current( id: any): boolean
		Editor_mode_icon( id: any): $mol_icon_code_braces
		editor_mode_link( id: any): Record<string, any>
		Editor_mode( id: any): $mol_link
		Editor_mode_action( id: any): $mol_view
		map_title_content( id: any): readonly(any)[]
		map_rename_start( id: any, next?: any ): any
		map_title_draft( id: any, next?: string ): string
		map_rename_submit( id: any, next?: any ): any
		map_rename_pointerdown( id: any, next?: any ): any
		map_rename_click( id: any, next?: any ): any
		map_rename_keydown( id: any, next?: any ): any
		public_hint( id: any): string
		Public_hint( id: any): $mol_svg_title
		Public_icon( id: any): $mol_icon_earth
		public_icon_visible( id: any): readonly(any)[]
		Menu_link_title( id: any): $mol_dimmer
		map_menu_links( ): readonly($mol_view)[]
		owned_tree_roots( next?: readonly(any)[] ): readonly(any)[]
		owned_tree_children( id: any, next?: readonly(any)[] ): readonly(any)[]
		project_expanded( id: any, next?: boolean ): boolean
		owned_tree_can_have_children( id: any): boolean
		owned_tree_can_be_child( id: any): boolean
		owned_tree_item_height( id: any): number
		Owned_tree_item( id: any): $mol_view
		project_item_content( id: any): readonly(any)[]
		project_menu_offset( id: any): readonly(any)[]
		project_rename_start( id: any, next?: any ): any
		Project_icon( id: any): $mol_icon_folder
		project_title( id: any): string
		Project_title_text( id: any): $mol_view
		Project_title( id: any): $mol_check
		project_contextmenu( id: any, next?: any ): any
		project_menu_rename( id: any, next?: any ): any
		Project_rename_action( id: any): $mol_button_minor
		project_delete( id: any, next?: any ): any
		Project_delete( id: any): $mol_button_minor
		project_menu_items( id: any): readonly(any)[]
		Project_menu_list( id: any): $mol_list
		project_delete_confirm( id: any, next?: any ): any
		project_delete_cancel( id: any, next?: any ): any
		project_delete_undo( next?: any ): any
		project_undo_title( ): string
		project_title_draft( id: any, next?: string ): string
		project_rename_submit( id: any, next?: any ): any
		project_rename_pointerdown( id: any, next?: any ): any
		project_rename_keydown( id: any, next?: any ): any
		Add_map_icon( ): $mol_icon_plus
		Add_map_anchor( ): $mol_button_minor
		add_map( id: any): any
		Add_private_icon( ): $mol_icon_plus
		Add_private( ): $mol_button_minor
		Add_public_icon( ): $mol_icon_plus
		Add_public( ): $mol_button_minor
		Add_public_edit_icon( ): $mol_icon_plus
		Add_public_edit( ): $mol_button_minor
		add_project( next?: any ): any
		Add_project_icon( ): $mol_icon_folder
		Add_project( ): $mol_button_minor
		import( next?: any ): any
		Import( ): $shm_hitalama_attach
		Add_map_menu( ): $mol_list
		Add_map( ): $mol_pop_over
		close_maps_list( next?: any ): any
		menu_filter( next?: string ): string
		sort_order( next?: ReturnType< ReturnType< $shm_hitalama_map_catalog['List_head'] >['sort_order'] > ): ReturnType< ReturnType< $shm_hitalama_map_catalog['List_head'] >['sort_order'] >
		sort_by( next?: string ): string
		List_head( ): $shm_list_head
		auto( ): readonly(any)[]
		menu_title( ): string
		Help( ): $shm_hitalama_guide_toggle
		maps_list_visible( next?: boolean ): boolean
		param( ): string
		title_default( ): string
		Page( id: any): $shm_hitalama_map_page
		Book( id: any): $shm_hitalama_map_book
		menu_item_content( id: any): readonly($mol_view)[]
		menu_link_content( id: any): readonly($mol_view_content)[]
		Menu_link( id: any): $mol_link
		Map_title_input( id: any): $mol_string
		Map_title( id: any): $mol_view
		menu_body( ): readonly(any)[]
		Map_menu_links( ): $mol_view
		Owned_tree( ): $shm_hitalama_dragtree
		Project_item( id: any): $mol_view
		Project_menu( id: any): $mol_pick
		Project_delete_confirm( id: any): $mol_button_major
		Project_delete_cancel( id: any): $mol_button_minor
		Project_undo( ): $mol_button_minor
		Project_title_input( id: any): $mol_string
		Visited_title( ): $mol_text
		Available_title( ): $mol_text
		menu_head( ): readonly($mol_view_content)[]
	}
	
}

//# sourceMappingURL=catalog.view.tree.d.ts.map